<template>
  <hm-content title="">
    <div class="">
      <div class="tip-msg flex flex-wrap">
        <div class="tip-img flex flex-column flex-center item-center">
          <img
                  src="https://imgcdn.hemiao100.com/ThemePictures/%E7%8C%B4%E5%AD%90.png"
                  alt=""
          />
          <div class="tip-name">小助理</div>
        </div>
        <div class="bubbleItem">
          <!--左侧的泡泡-->
          <span class="bubble leftBubble">
            亲爱的BOSS，助理小H来帮助您创建计划啦！
            <span class="bottomLevel"></span>
            <span class="topLevel"></span>
          </span>
        </div>
      </div>
      <div class="x-scroll">
        <div class="mt10 flex item-center" style="height: 600px">
          <el-tooltip
                  :disabled="
              okrPlanBasicInfo.okrPlanBasicInfoState === 'completed' ||
                okrPlanBasicInfo.okrPlanBasicInfoState === 'disable'
            "
                  class="item"
                  effect="dark"
                  content="制定总目标"
                  placement="top"
          >
            <div class="ork-module inline-block mr110">
              <div
                      class="ork-module-btn-wrapper"
                      v-if="okrPlanBasicInfo.okrPlanBasicInfoState === 'completed'"
              >
                <div class="flex item-center wrapper">
                  <div class="flex flex-wrap flex-start">
                    <el-tooltip
                            class="item"
                            content="编辑"
                            placement="top"
                            style="color: #0081e5"
                    >
                      <el-button
                              @click="edit('1', '制定总目标')"
                              icon="hmicon icon-bianji"
                              circle
                      ></el-button>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div
                      class="okr-img flex flex-center item-center pointer"
                      @click="goAdd('1', '制定总目标')"
              >
                <img
                        src="https://imgcdn.hemiao100.com/ThemePictures/%E5%AE%9A%E5%88%B6%E6%80%BB%E7%9B%AE%E6%A0%87%402x.png"
                        alt=""
                />
              </div>

              <!-- <div class="flex flex-center ork-title">1.制定总目标</div> -->
              <div class="flex flex-center mt20">
                <el-button
                        v-if="okrPlanBasicInfo.okrPlanBasicInfoState === 'completed'"
                        type="primary"
                        class="okr-btn-success"
                        size="small"
                >
                  <span class="hmicon icon-duigou"></span>
                </el-button>
                <el-button
                        v-if="okrPlanBasicInfo.okrPlanBasicInfoState === 'disable'"
                        type="primary"
                        size="small"
                        class="okr-btn-false"
                        :disabled="true"
                >去制定</el-button
                >
                <el-button
                        v-if="okrPlanBasicInfo.okrPlanBasicInfoState === 'editing'"
                        type="primary okr-btn"
                        size="small"
                        @click="goAdd('1', '制定总目标')"
                >去制定</el-button
                >
              </div>
              <!-- <div
              class="pointer edit"
              @click="edit('1', '制定总目标')"
              v-if="okrPlanBasicInfo.okrPlanBasicInfoState === 'completed'"
            >
              <span class="hmicon icon-bianji blue"></span>
            </div> -->
              <div class="line"></div>
            </div>
          </el-tooltip>
          <el-tooltip
                  :disabled="okrPlanBasicInfo.okrPlanSplitInfoState === 'completed'"
                  class="item"
                  effect="dark"
                  :content="
              okrPlanBasicInfo.okrPlanSplitInfoState === 'editing'
                ? '目标拆分'
                : '请先完成上一步哦!'
            "
                  placement="top"
          >
            <div class="ork-module inline-block mr110">
              <div
                      class="ork-module-btn-wrapper"
                      v-if="okrPlanBasicInfo.okrPlanSplitInfoState === 'completed'"
              >
                <div class="flex item-center wrapper">
                  <div class="flex flex-wrap flex-start">
                    <el-tooltip
                            class="item"
                            content="编辑"
                            placement="top"
                            style="color: #0081e5"
                    >
                      <el-button
                              @click="edit('2', '目标拆分')"
                              icon="hmicon icon-bianji"
                              circle
                      ></el-button>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div
                      class="okr-img flex flex-center item-center pointer"
                      v-if="okrPlanBasicInfo.okrPlanSplitInfoState === 'editing'"
                      @click="goAdd('2', '目标拆分')"
              >
                <img
                        src="https://imgcdn.hemiao100.com/ThemePictures/%E6%8B%86%E5%88%86%E7%9B%AE%E6%A0%87%402x.png"
                        alt=""
                />
              </div>
              <div class="okr-img flex flex-center item-center" v-else>
                <img
                        src="https://imgcdn.hemiao100.com/ThemePictures/%E6%8B%86%E5%88%86%E7%9B%AE%E6%A0%87%402x.png"
                        alt=""
                />
              </div>

              <!-- <div class="flex flex-center ork-title">2.目标拆分</div> -->
              <div class="flex flex-center mt20">
                <el-button
                        type="primary"
                        size="small"
                        class="okr-btn-false"
                        :disabled="true"
                        v-if="okrPlanBasicInfo.okrPlanSplitInfoState === 'disable'"
                >去拆分</el-button
                >
                <el-button
                        type="primary okr-btn"
                        @click="goAdd('2', '目标拆分')"
                        size="small"
                        v-if="okrPlanBasicInfo.okrPlanSplitInfoState === 'editing'"
                >去拆分</el-button
                >
                <el-button
                        type="primary"
                        v-if="okrPlanBasicInfo.okrPlanSplitInfoState === 'completed'"
                        class="okr-btn-success"
                        size="small"
                >
                  <span class="hmicon icon-duigou"></span>
                </el-button>
              </div>
              <!-- <div
              class="pointer edit"
              @click="edit('2', '目标拆分')"
              v-if="okrPlanBasicInfo.okrPlanSplitInfoState === 'completed'"
            >
              <span class="hmicon icon-bianji blue"></span>
            </div> -->
              <div class="line"></div>
            </div>
          </el-tooltip>
          <el-tooltip
                  :disabled="
                  okrPlanBasicInfo.okrPlanSplitTargetInfoState === 'completed'
                "
                  class="item"
                  effect="dark"
                  :content="
                  okrPlanBasicInfo.okrPlanSplitTargetInfoState === 'editing'
                    ? '细分子目标'
                    : '请先完成上一步哦!'
                "
                  placement="top"
          >
            <div class="ork-module inline-block mr110">
              <div
                      class="ork-module-btn-wrapper"
                      v-if="
                      okrPlanBasicInfo.okrPlanSplitTargetInfoState ===
                        'completed'
                    "
              >
                <div class="flex item-center wrapper">
                  <div class="flex flex-wrap flex-start">
                    <el-tooltip
                            class="item"
                            content="编辑"
                            placement="top"
                            style="color: #0081e5"
                    >
                      <el-button
                              @click="edit('3', '细分子目标')"
                              icon="hmicon icon-bianji"
                              circle
                      ></el-button>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div
                      v-if="
                      okrPlanBasicInfo.okrPlanSplitTargetInfoState === 'editing'
                    "
                      class="okr-img flex flex-center item-center pointer"
                      @click="goAdd('3', '细分子目标')"
              >
                <img
                        src="https://imgcdn.hemiao100.com/ThemePictures/%E7%BB%86%E5%88%86%E5%AD%90%E7%9B%AE%E6%A0%87%25402x.png"
                        alt=""
                />
              </div>
              <div v-else class="okr-img flex flex-center item-center">
                <img
                        src="https://imgcdn.hemiao100.com/ThemePictures/%E7%BB%86%E5%88%86%E5%AD%90%E7%9B%AE%E6%A0%87%25402x.png"
                        alt=""
                />
              </div>

              <!-- <div class="flex flex-center ork-title">4.细分子目标</div> -->
              <div class="flex flex-center mt20">
                <el-button
                        @click="goAdd('3', '细分子目标')"
                        type="primary okr-btn"
                        size="small"
                        v-if="
                        okrPlanBasicInfo.okrPlanSplitTargetInfoState ===
                          'editing'
                      "
                >去细分</el-button
                >
                <el-button
                        type="primary"
                        class="okr-btn-success"
                        size="small"
                        v-if="
                        okrPlanBasicInfo.okrPlanSplitTargetInfoState ===
                          'completed'
                      "
                >
                  <span class="hmicon icon-duigou"></span>
                </el-button>
                <el-button
                        type="primary"
                        size="small"
                        class="okr-btn-false"
                        :disabled="true"
                        v-if="
                        okrPlanBasicInfo.okrPlanSplitTargetInfoState ===
                          'disable'
                      "
                >去细分</el-button
                >
              </div>
              <!-- <div
                class="pointer edit"
                @click="edit('4', '细分子目标')"
                v-if="
                  okrPlanBasicInfo.okrPlanSplitTargetInfoState ===
                  'completed'
                "
              >
                <span class="hmicon icon-bianji blue"></span>
              </div> -->
              <div class="line"></div>

            </div>
          </el-tooltip>
          <el-tooltip
                  :disabled="
                  okrPlanBasicInfo.okrPlanSplitShopInfoState === 'completed'
                "
                  class="item"
                  effect="dark"
                  :content="
                  okrPlanBasicInfo.okrPlanSplitShopInfoState === 'editing'
                    ? '细分门店目标'
                    : '请先完成上一步哦!'
                "
                  placement="top"
          >
            <div class="ork-module">
              <div
                      class="ork-module-btn-wrapper"
                      v-if="
                      okrPlanBasicInfo.okrPlanSplitShopInfoState === 'completed'
                    "
              >
                <div class="flex item-center wrapper">
                  <div class="flex flex-wrap flex-start">
                    <el-tooltip
                            class="item"
                            content="编辑"
                            placement="top"
                            style="color: #0081e5"
                    >
                      <el-button
                              @click="edit('4', '细分门店目标')"
                              icon="hmicon icon-bianji"
                              circle
                      ></el-button>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div
                      class="okr-img flex flex-center item-center pointer"
                      v-if="
                      okrPlanBasicInfo.okrPlanSplitShopInfoState === 'editing'
                    "
                      @click="goAdd('4', '细分门店目标')"
              >
                <img
                        src="https://imgcdn.hemiao100.com/ThemePictures/%E7%BB%86%E5%88%86%E9%97%A8%E5%BA%97.png"
                        alt=""
                />
              </div>
              <div v-else class="okr-img flex flex-center item-center">
                <img
                        src="https://imgcdn.hemiao100.com/ThemePictures/%E7%BB%86%E5%88%86%E9%97%A8%E5%BA%97.png"
                        alt=""
                />
              </div>

              <!-- <div class="flex flex-center ork-title">3.细分门店目标</div> -->
              <div class="flex flex-center mt20">
                <el-button
                        type="primary"
                        class="okr-btn-success"
                        size="small"
                        v-if="
                        okrPlanBasicInfo.okrPlanSplitShopInfoState ===
                          'completed'
                      "
                >
                  <span class="hmicon icon-duigou"></span>
                </el-button>
                <el-button
                        type="primary okr-btn"
                        size="small"
                        @click="goAdd('4', '细分门店目标')"
                        v-if="
                        okrPlanBasicInfo.okrPlanSplitShopInfoState === 'editing'
                      "
                >去细分
                </el-button>
                <el-button
                        type="primary"
                        size="small"
                        class="okr-btn-false"
                        :disabled="true"
                        v-if="
                        okrPlanBasicInfo.okrPlanSplitShopInfoState === 'disable'
                      "
                >去细分</el-button
                >
              </div>
              <!-- <div
                class="pointer edit"
                @click="edit('3', '细分门店目标')"
                v-if="
                  okrPlanBasicInfo.okrPlanSplitShopInfoState === 'completed'
                "
              >
                <span class="hmicon icon-bianji blue"></span>
              </div> -->
              <div class="line"></div>
            </div>
          </el-tooltip>
          <el-tooltip
                  :disabled="
              okrPlanBasicInfo.okrPlanSplitDetailInfoState === 'completed'
            "
                  class="item"
                  effect="dark"
                  :content="
              okrPlanBasicInfo.okrPlanSplitDetailInfoState === 'editing'
                ? '预览'
                : '请先完成上一步哦!'
            "
                  placement="top"
          >
            <div class="ork-module inline-block ml110">
              <div class="left-line"></div>
              <div
                      v-if="
                  okrPlanBasicInfo.okrPlanSplitDetailInfoState === 'editing'
                "
                      class="okr-img flex flex-center item-center pointer"
                      @click="goAdd('5', '预览')"
              >
                <img
                        src="https://imgcdn.hemiao100.com/ThemePictures/%E9%A2%84%E8%A7%88%E5%B9%B6%E5%8F%91%E5%B8%83%402x.png"
                        alt=""
                />
              </div>
              <div v-else class="okr-img flex flex-center item-center">
                <img
                        src="https://imgcdn.hemiao100.com/ThemePictures/%E9%A2%84%E8%A7%88%E5%B9%B6%E5%8F%91%E5%B8%83%402x.png"
                        alt=""
                />
              </div>

              <!-- <div class="flex flex-center ork-title">5.预览与发布</div> -->
              <div class="flex flex-center mt20">
                <el-button
                        v-if="
                    okrPlanBasicInfo.okrPlanSplitDetailInfoState === 'completed'
                  "
                        type="primary"
                        class="okr-btn-success"
                        size="small"
                >
                  <span class="hmicon icon-duigou"></span>
                </el-button>
                <el-button
                        type="primary"
                        size="small"
                        class="okr-btn-false"
                        :disabled="true"
                        v-if="
                    okrPlanBasicInfo.okrPlanSplitDetailInfoState === 'disable'
                  "
                >去预览</el-button
                >
                <el-button
                        @click="goAdd('5', '预览')"
                        v-if="
                    okrPlanBasicInfo.okrPlanSplitDetailInfoState === 'editing'
                  "
                        type="primary okr-btn"
                        size="small"
                >去预览</el-button
                >
              </div>
              <div class="okr-tip-bubble">
                <span class="bubble leftBubble">
                  <span class="title">发布成功后还需要</span>

                  <span class="bottomLevel"></span>
                  <span class="topLevel"></span>
                  <p class="child flex item-center">
                    <span class="hmicon icon-daiban mr10"></span> 主管拆分子目标
                  </p>
                  <p class="child flex item-center">
                    <span class="hmicon icon-daiban mr10"></span>
                    店长拆分门店目标
                  </p>
                  <p class="child flex item-center">
                    <span class="hmicon icon-daiban mr10"></span> 导购执行目标
                  </p>
                </span>
              </div>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
    <el-dialog
            :title="title"
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            :width="
        type != 1 && type != 2 ? '1300px' : type === '1' ? '700px' : '880px'
      "
    >
      <div class="tip-msg flex flex-wrap">
        <div class="tip-img flex flex-column flex-center item-center">
          <img
                  src="https://imgcdn.hemiao100.com/ThemePictures/%E7%8C%B4%E5%AD%90.png"
                  alt=""
          />
          <div class="tip-name">小助理</div>
        </div>
        <div class="bubbleItem">
          <!--左侧的泡泡-->
          <span class="bubble leftBubble" v-if="type === '1'">
            首先您需要填下目标信息！
            <span class="bottomLevel"></span>
            <span class="topLevel"></span>
          </span>
          <span class="bubble leftBubble" v-if="type === '2'">
            总目标定制了，需要细分，请您输入在总目标中的占比，系统将依据此数据分配您的目标;总比例=100%，若比例有剩余则不可进行下一步！
            <span class="bottomLevel"></span>
            <span class="topLevel"></span>
          </span>
          <span class="bubble leftBubble" v-if="type === '3'">
            开始细分子目标啦，请输入子目标比例，总比例=100%，若比例有剩余则不可进行下一步！
            <span class="bottomLevel"></span>
            <span class="topLevel"></span>
          </span>
          <span class="bubble leftBubble" v-if="type === '4'">
            请输入门店比例，总比例=100%，若比例有剩余则不可进行下一步！
            <span class="bottomLevel"></span>
            <span class="topLevel"></span>
          </span>
          <span class="bubble leftBubble" v-if="type === '5'">
            最后一步啦！预览之后点去发布即可！
            <span class="bottomLevel"></span>
            <span class="topLevel"></span>
          </span>
        </div>
      </div>
      <div class="mt10" v-if="type === '1'">
        <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="142px"
        >
          <el-form-item label="目标名称" prop="planName">
            <el-input
                    size="small"
                    clearable
                    class="mr10 ipt"
                    maxlength="38"
                    style="width: 300px"
                    v-model.trim="ruleForm.planName"
                    placeholder="例如：2021年1-6月半年计划目标5000万"
            ></el-input>
          </el-form-item>
          <el-form-item label="目标类型" prop="planType">
            <el-radio-group
                    v-model="ruleForm.planType"
                    @change="planTypeChange"
            >
              <el-radio label="salesAmount">销售金额</el-radio>
              <el-radio label="salesNum">销售数量</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="目标金额" prop="planValue" v-if="this.ruleForm.planType === 'salesAmount' "  >
            <el-input
                    size="small"
                    clearable
                    class="mr10 ipt"
                    maxlength="38"
                    style="width: 300px"
                    @input="filterGt0OrFixed2('planValue')"
                    v-model.trim="ruleForm.planValue"
                    placeholder="请输入目标金额"
            >
              <i slot="prefix" style="color: #222" class="hmicon icon-qian"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="目标数量" prop="planValue" v-if="this.ruleForm.planType === 'salesNum' ">
            <el-input
                    size="small"
                    clearable
                    class="mr10 ipt"
                    maxlength="38"
                    style="width: 300px"
                    @input="filterGt0OrFixed2('planValue')"
                    v-model.trim="ruleForm.planValue"
                    placeholder="请输入目标数量"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="起止时间" prop="timeType">
            <el-radio-group
                    v-model="ruleForm.timeType"
                    @change="drawDateChange"
            >
              <el-radio label="year">按年</el-radio>
              <el-radio label="month">按月</el-radio>
              <el-radio label="date">按日</el-radio>
            </el-radio-group>
            <div>
              <el-date-picker
                      key="planStartDateyear"
                      v-if="ruleForm.timeType === 'year'"
                      size="small"
                      v-model="ruleForm.planStartDate"
                      ref="datepicker"
                      value-format="yyyy"
                      type="year"
                      placeholder="开始年份"
                      style="width: 145px"
                      :picker-options="pickerStartOptions"
              >
              </el-date-picker>
              <span v-if="ruleForm.timeType === 'year'">至</span>
              <el-date-picker
                      key="planEndDateyear"
                      :disabled="
                  ruleForm.planStartDate === '' ||
                    ruleForm.planStartDate == null
                "
                      :picker-options="pickerOptions"
                      v-if="ruleForm.timeType === 'year'"
                      size="small"
                      v-model="ruleForm.planEndDate"
                      ref="datepicker"
                      value-format="yyyy"
                      type="year"
                      style="width: 145px"
                      placeholder="截止年份"
              >
              </el-date-picker>
              <el-date-picker
                      key="planEndDatemonth"
                      v-if="ruleForm.timeType === 'month'"
                      size="small"
                      v-model="ruleForm.timeDate"
                      ref="datepicker"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptionsMonth"
                      type="monthrange"
                      range-separator="至"
                      start-placeholder="开始月份"
                      end-placeholder="结束月份"
              >
              </el-date-picker>
              <el-date-picker
                      key="planEndDatedate"
                      v-if="ruleForm.timeType === 'date'"
                      size="small"
                      v-model="ruleForm.timeDate"
                      ref="datepicker"
                      :picker-options="pickerOptionsDate"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      style="width: 300px"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="负责人" prop="planLeaderId">
            <el-input
                    size="small"
                    class="mr10 ipt"
                    :show-message="showGoodsSn"
                    v-model.trim="ruleForm.realName"
                    placeholder="请选择责任人"
                    @click.native="selectEmp"
                    style="width: 300px"
                    readonly
            ></el-input>
            <!-- <el-select
              clearable
              size="small"
              v-model="ruleForm.planLeaderId"
              placeholder="请选择责任人"
              filterable
              style="width: 300px"
            >
              <el-option
                :label="v.realname"
                :value="v.employeeId"
                v-for="(v, i) in allEmp"
                :key="i"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
        </el-form>
      </div>
      <div class="mt10" v-if="type === '2'">
        <div class="flex flex-between mb10">
          <div>
            <div class="fz16">目标<b v-if="planType==='salesAmount'">金额：</b><b v-if="planType==='salesNum'">数量：</b><span style="color: #ff7f10;font-weight:bold">{{planValue}}</span>
              <span style="padding-left: 50px;">
              剩余<b v-if="planType==='salesAmount'">金额</b><b v-if="planType==='salesNum'">数量</b>：<span style="color: #ff7f10;font-weight:bold">
                {{ remainingRatio }}</span>
              </span>
            </div>
          </div>
          <!--           <div>-->
          <!--            <el-popover placement="top-end" width="300" trigger="hover">-->
          <!--              <div>-->
          <!--                剩余比例将自动填充到未拆分比例的部分。-->
          <!--              </div>-->
          <!--              <el-button-->
          <!--                  slot="reference"-->
          <!--                  type="primary"-->
          <!--                  @click="autoFill"-->
          <!--                  size="small"-->
          <!--              >自动填充</el-button-->
          <!--              >-->
          <!--            </el-popover>-->
          <!--          </div>-->
        </div>

        <div class="columnList">
          <el-form
                  :rules="model.rules"
                  :model="model"
                  ref="ruleForm"
                  label-width="0px"
          >
            <!-- <el-form-item prop="list" :rules='model.rules.list' > -->
            <el-table
                    :data="model.list"
                    style="width: 100%;"
                    border
                    stripe
                    size="small"
                    show-summary
                    :max-height="400"
                    :summary-method="getSummaries"
            >
              <el-table-column
                      header-align="center"
                      align="center"
                      type="index"
                      label="序号"
                      width="50"
              ></el-table-column>
              <el-table-column
                      prop="timeValue"
                      label="时间"
                      header-align="center"
                      align="center"
              >
              </el-table-column>
              <el-table-column
                      prop="splitValue"
                      v-if="planType === 'salesAmount'"
                      label="目标金额"
                      header-align="center"
              >
                <template slot-scope="scope" header-align="center">
                  <el-form-item
                          class="from-err"
                          :prop="'list.' + scope.$index + '.splitValue'"
                          :rules="model.rules.splitValue"
                          header-align="center"
                  >
                    <el-input
                            size="small"
                            class="mr10 ipt text-center"
                            maxlength="38"
                            width="150px"
                            :ref="'list.' + scope.$index + '.splitValue'"
                            @blur="percentageBlur(scope.$index)"
                            @input="
                        filterGt0OrListModelFixed2(
                          'splitValue',
                          scope.$index,
                          'list'
                        )
                      "
                            v-model.trim="scope.row.splitValue"
                            placeholder="请输入目标金额"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                  prop="splitValue"
                  v-if="planType === 'salesNum'"
                  label="目标数量"
                  header-align="center"
              >
                <template slot-scope="scope" header-align="center">
                  <el-form-item
                      class="from-err"
                      :prop="'list.' + scope.$index + '.splitValue'"
                      :rules="model.rules.splitValue"
                      header-align="center"
                  >
                    <el-input
                        size="small"
                        class="mr10 ipt text-center"
                        maxlength="38"
                        width="150px"
                        :ref="'list.' + scope.$index + '.splitValue'"
                        @blur="percentageBlur(scope.$index)"
                        @input="
                        filterGt0OrListModelFixed2(
                          'splitValue',
                          scope.$index,
                          'list'
                        )
                      "
                        v-model.trim="scope.row.splitValue"
                        placeholder="请输入目标数量"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                      prop="splitRatio"
                      label="百分比(%)"
                      header-align="center"
                      align="center"
                      width="330px"
              >
                <template slot-scope="scope">
                  <div>
                    <!-- {{scope.row}} -->
                    {{ scope.row.splitRatio }}
                    <span v-if="scope.row.splitRatio !== ''">%</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="form-red" v-if="errShow">
              上下滑动滑动，您还有未填写的哟！
            </div>
            <!-- </el-form-item> -->
          </el-form>
        </div>
      </div>
      <div class="mt10" v-if="type === '3'">
        <div class="flex flex-between mb10">
          <div class="fz16">目标<b v-if="planType==='salesAmount'">金额：</b><b v-if="planType==='salesNum'">数量：</b><span style="color: #ff7f10;font-weight:bold">{{planValue}}</span>
            <span style="padding-left: 50px;">
            剩余<b v-if="planType==='salesAmount'">金额</b><b v-if="planType==='salesNum'">数量</b>：<span style="color: #ff7f10;font-weight:bold">
                {{remainingRatio}}</span>
            </span>
          </div>
        </div>
        <div class="columnList">
          <el-form
                  :rules="model.rules"
                  :model="model"
                  ref="ruleForm"
                  label-width="0px"
                  class="okr-table-form"
          >
            <el-table
                    :data="model.columnList"
                    style="width: 100%"
                    border
                    stripe
                    ref="columnList"
                    size="small"
                    :max-height="400"
                    :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
                    :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            >
              <el-table-column
                      header-align="center"
                      align="center"
                      type="index"
                      label="序号"
                      width="50"
              ></el-table-column>

              <el-table-column
                      v-for="(col, index) in headersList"
                      :key="index"
                      max-width="280px"
                      :min-width="
                  index <= 2 ? (index === 0 ? '280px' : '200px') : '130px'
                "
                      :prop="col.columnName"
                      :label="col.labelName1"
                      header-align="center"
                      :align="index <= 2 ? 'left' : 'right'"
                      :column-key="col.columnName"
              >
                <template slot="header">
                  <!-- <div class="flex flex-column flex-between"> -->
                  <div class="flex flex-center">
                    {{ col.labelName1 }}
                    <div
                            @click="add"
                            class="add-wrapper flex flex-center item-center"
                            v-if="col.columnName === 'planName'"
                    >
                      <span class="hmicon icon-hao pointer"></span>
                    </div>
                  </div>
                  <p
                          class="bm flex-center pt10"
                          v-if="index !== 0"
                          :class="index > 2 ? 'flex-end' : 'flex-center'"
                  >
                    <span v-if="index > 2 && planType === 'salesAmount' "  >￥</span>
                    <span v-if="index > 2 && planType === 'salesAmount' " >{{
                        index > 2
                            ? toPriceNum(col.labelName2.toFixed(2))
                            : col.labelName2
                      }}</span>
                    <span v-if="index > 2 && planType === 'salesNum' " >{{
                        col.labelName2
                      }}</span>
                    <!--                    {{ index === 2 ? "%" : "" }}-->
                  </p>
                  <!-- </div> -->
                </template>
                <template slot-scope="scope">
                  <el-form-item
                          class="from-err-plan-name"
                          v-if="col.columnName === 'planName'"
                          :prop="'columnList.' + scope.$index + '.planName'"
                          :rules="model.rules.planName"
                  >
                    <div class="flex item-center">
                      <el-input
                              size="small"
                              clearable
                              class="mr10 inputfo"
                              maxlength="20"
                              style="width: 150px"
                              v-model.trim="scope.row[col.columnName]"
                              placeholder="子目标内容"
                      ></el-input>
                      <div
                              @click="del(scope.$index)"
                              class="minus-wrapper flex flex-center item-center inline-block"
                              v-if="col.columnName === 'planName'"
                      >
                        <span class="hmicon icon-jianhao pointer"></span>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item
                          class="from-err-ratio text-center"
                          v-else-if="col.labelName1 === '负责人'"
                          :prop="'columnList.' + scope.$index + '.planLeaderId'"
                          :rules="model.rules.planLeaderId"
                  >
                    <el-input
                            size="small"
                            class="mr10 ipt text-center"
                            :show-message="scope.row.showGoodsSn"
                            v-model.trim="scope.row.planLeaderName"
                            placeholder="请选择责任人"
                            @click.native="selectEmpList(scope.$index, 'list')"
                            style="width: 120px"
                            readonly
                    ></el-input>

                    <!-- <el-select
                  clearable
                  size="small"
                  v-model="scope.row.planLeaderId"
                  placeholder="负责人"
                  filterable
                  style="width:190px"
                >
                  <el-option
                    :label="v.realname"
                    :value="v.employeeId"
                    v-for="(v, i) in allEmp"
                    :key="i"
                  >
                  </el-option>
                </el-select> -->
                  </el-form-item>
                  <div v-else-if="col.columnName === 'planValue'">
                    <el-form-item
                            class="from-err-ratio"
                            style="text-align: center;"
                            :prop="'columnList.' + scope.$index + '.planValue'"
                            :rules="model.rules.planValue"
                    >
                      {{scope.row[col.columnName]}}

                    </el-form-item>
                  </div>
                  <div v-else>
                    <el-input
                            size="small"
                            class="mr10 ipt text-center"
                            maxlength="38"
                            style="width: 100px;text-align: center;"
                            v-model.trim="scope.row[col.columnName]"
                            clearable
                            @blur="targetBlur(scope.row[col.columnName], scope.row, scope.$index)"
                    ></el-input>

                    <!--                    <span v-if="scope.row[col.columnName] != ''">￥</span>-->
                    <!--                    {{ toPriceNum(scope.row[col.columnName]) }}-->
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
      </div>
      <div class="mt10" v-if="type === '4'">
        <div class="flex mb10 fz16">
          <div class="mr65">当前门店数(家）：{{ model.columnList.length }}</div>
          <div class="fz16">目标<b v-if="planType==='salesAmount'">金额：</b><b v-if="planType==='salesNum'">数量：</b><span style="color: #ff7f10;font-weight:bold">{{planValue}}</span></div>
          <div class="fz16" style="padding-left: 50px;">
            剩余<b v-if="planType==='salesAmount'">金额</b><b v-if="planType==='salesNum'">数量</b>：<span style="color: #ff7f10;font-weight:bold">
                {{ remainingRatio }}</span
          >
          </div>
        </div>
        <div class="columnList">
          <el-form
                  :rules="model.rules"
                  :model="model"
                  ref="ruleForm"
                  label-width="0px"
                  class="okr-table-form"
          >
            <el-table
                    :data="model.columnList"
                    style="width: 100%"
                    border
                    stripe
                    ref="columnList"
                    size="small"
                    :max-height="400"
                    :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
                    :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            >
              <el-table-column
                      header-align="center"
                      align="center"
                      type="index"
                      label="序号"
                      width="50"
              ></el-table-column>

              <el-table-column
                      v-for="(col, index) in headersList"
                      :key="index"
                      max-width="280px"
                      :min-width="
                  index <= 2 ? (index === 0 ? '280px' : '200px') : '130px'
                "
                      :prop="col.columnName"
                      :label="col.labelName1"
                      header-align="center"
                      :align="index <= 2 ? 'left' : 'right'"
                      :column-key="col.columnName"
              >
                <template slot="header">
                  <!-- <div class="flex flex-column flex-between"> -->
                  <div class="flex text-center">
                    {{ col.labelName1 }}
                    <div
                        v-if="col.columnName === 'shopName'"
                        @click="addShops"
                        class="add-wrapper flex flex-center item-center"
                    >
                      <span class="hmicon icon-hao pointer"></span>
                    </div>
                  </div>
                  <p
                          class="bm flex pt10"
                          v-if="index !== 0"
                          :class="index > 2 ? 'flex-end' : 'flex-center'"
                  >
                    <span v-if="index > 2 && planType === 'salesAmount' "  >￥</span>
                    <span v-if="index > 2 && planType === 'salesAmount' " >{{
                        index > 2
                            ? toPriceNum(col.labelName2.toFixed(2))
                            : col.labelName2
                      }}</span>
                    <span v-if="index > 2 && planType === 'salesNum' " >{{
                        col.labelName2
                      }}</span>
                    {{ index === 2 ? "%" : "" }}
                  </p>
                  <!-- </div> -->
                </template>
                <template slot-scope="scope">
                  <el-form-item
                          class="from-err-plan-name"
                          v-if="col.columnName === 'planName'"
                          :prop="'columnList.' + scope.$index + '.planName'"
                          :rules="model.rules.planName"
                  >
                    <div class="flex item-center">
                      <el-input
                              size="small"
                              clearable
                              class="mr10 inputfo"
                              maxlength="20"
                              style="width: 150px"
                              v-model.trim="scope.row[col.columnName]"
                              placeholder="子目标内容"
                      ></el-input>
                      <div
                              @click="del(scope.$index)"
                              class="minus-wrapper flex flex-center item-center inline-block"
                              v-if="col.columnName === 'planName'"
                      >
                        <span class="hmicon icon-jianhao pointer"></span>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item
                          class="from-err-ratio"
                          v-else-if="col.labelName1 === '负责人'"
                          :prop="'columnList.' + scope.$index + '.planLeaderId'"
                          :rules="model.rules.planLeaderId"
                  >
                    <el-input
                            size="small"
                            class="mr10 ipt text-center"
                            :show-message="scope.row.showGoodsSn"
                            v-model.trim="scope.row.planLeaderName"
                            @click.native="selectEmpList(scope.$index, 'list')"
                            style="width: 120px"
                            placeholder="请选择责任人"
                            readonly
                    ></el-input>
                    <!-- <el-select

                  clearable
                  size="small"
                  v-model="scope.row.planLeaderId"
                  placeholder="负责人"
                  filterable
                >
                  <el-option
                    :label="v.realname"
                    :value="v.employeeId"
                    v-for="(v, i) in allEmp"
                    :key="i"
                  >
                  </el-option>
                </el-select> -->
                  </el-form-item>
                  <el-form-item
                          class="from-err-ratio text-center"
                          style="text-align:center;"
                          v-else-if="col.columnName === 'planValue'"
                          :prop="'columnList.' + scope.$index + '.planValue'"
                          :rules="model.rules.planValue"
                  >
                    <div class="from-err-ratio">
                      {{scope.row[col.columnName]}}
                    </div>
                  </el-form-item>
                  <div v-else>
                      <div
                          v-if="col.columnName === 'shopName'"
                          @click="del(scope.$index)"
                          class="minus-wrapper flex flex-center item-center inline-block"
                      >
                        <span class="hmicon icon-jianhao pointer"></span>
                      </div>
                    <el-tooltip
                        v-if="index < 2"
                        :content="scope.row[col.columnName] + ''"
                        placement="top-start"
                    >
                      <div class="flex-1 text-overflow">
                        {{
                          scope.row[col.columnName]
                        }}
                      </div>
                    </el-tooltip>
                    <el-input
                        v-if="index > 2"
                        size="small"
                        class="bm flex pt10 text-center"
                        maxlength="38"
                        style="width: 100px;text-align: center;"
                        v-model.trim="scope.row[col.columnName]"
                        @blur="targetBlur(scope.row[col.columnName], scope.row, scope.$index)"
                    ></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
      </div>
      <div class="mt10" v-if="type === '5'">
        <el-radio-group
                v-model="searchCondition.subjectName"
                size="small"
                @change="subjectNameChange"
        >
          <el-radio-button label="shop">门店目标分时段</el-radio-button>
          <el-radio-button label="child">子目标分时段</el-radio-button>
          <el-radio-button label="shopAndChild">子目标分门店</el-radio-button>
        </el-radio-group>
        <div class="mt10">
          <el-table
                  :data="columnList"
                  style="width: 100%"
                  border
                  stripe
                  size="small"
                  :max-height="400"
                  :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
                  :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                  key="table"
          >
            <el-table-column
                    header-align="center"
                    align="center"
                    type="index"
                    label="序号"
                    width="50"
            ></el-table-column>

            <el-table-column
                    v-for="(col, index) in headersList"
                    :key="index"
                    :min-width="index === 0 ? 120 : 120"
                    :prop="col.columnName"
                    :label="col.labelName1"
                    header-align="center"
                    :align="
                searchCondition.subjectName !== 'shopAndChild'
                  ? index > 2
                    ? 'right'
                    : 'center'
                  : index >= 2
                  ? 'right'
                  : 'center'
              "
                    :column-key="index.toString()"
                    show-overflow-tooltip
            >
              <template slot="header">
                <!-- <div class="flex flex-column flex-between"> -->
                <div class="flex flex-center">{{ col.labelName1 }}</div>
                <p
                        class="bm flex  pt10"
                        v-if="
                    col.columnName !== 'shopName' &&
                      searchCondition.subjectName === 'shop'
                  "
                        :class="index > 2 ? 'flex-end' : 'flex-center'"
                >
                  {{
                  searchCondition.subjectName != "shopAndChild"
                  ? index > 2
                  ? "￥"
                  : ""
                  : index > 1
                  ? "￥"
                  : ""
                  }}
                  {{
                  index > 2
                  ? toPriceNum(col.labelName2.toFixed(2))
                  : col.labelName2
                  }}

                  {{ col.columnName === "splitRatio" ? "%" : "" }}
                </p>
                <p
                        class="bm flex  pt10"
                        v-if="
                    col.columnName !== 'planName' &&
                      searchCondition.subjectName === 'child'
                  "
                        :class="index > 2 ? 'flex-end' : 'flex-center'"
                >
                  {{
                  searchCondition.subjectName != "shopAndChild"
                  ? index > 2
                  ? "￥"
                  : ""
                  : index > 1
                  ? "￥"
                  : ""
                  }}
                  {{
                  index > 2
                  ? toPriceNum(col.labelName2.toFixed(2))
                  : col.labelName2
                  }}
                  {{ col.columnName === "splitRatio" ? "%" : "" }}
                </p>
                <!-- </div> -->
              </template>
              <template slot-scope="scope">
                <div v-if="col.labelName1 === '负责人'">
                  {{ scope.row[col.columnName] }}
                </div>
                <!-- <div v-else-if="col.columnName==='splitRatio'">

                  <el-input
                  size="small"
                  clearable
                  class="mr10 ipt"
                  maxlength="38"
                  @blur="labelNameBlur(scope.row,col.columnName)"
                  @input="filterGt0OrListFixed2('splitRatio', scope.$index,'columnList')"
                  v-model.trim="scope.row[col.columnName]"
                  placeholder="请输入百分比"
                ></el-input>
            </div> -->
                <div v-else>
                  {{
                  searchCondition.subjectName != "shopAndChild"
                  ? index > 2
                  ? "￥"
                  : ""
                  : index > 1
                  ? "￥"
                  : ""
                  }}
                  <!-- {{index>2?toPriceNum(scope.row[col.columnName].toFixed(2)):col.labelName2}}
                  {{ scope.row[col.columnName] }} -->
                  {{
                  searchCondition.subjectName != "shopAndChild"
                  ? index > 2
                  ? toPriceNum(scope.row[col.columnName].toFixed(2))
                  : scope.row[col.columnName]
                  : index > 1
                  ? toPriceNum(scope.row[col.columnName].toFixed(2))
                  : scope.row[col.columnName]
                  }}
                  {{ col.columnName === "splitRatio" ? "%" : "" }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer flex flex-center">
        <el-button
                @click="submitRuleForm('ruleForm')"
                size="small"
                type="primary"
        >{{ this.type === "5" ? "发布" : "保存" }}</el-button
        >

        <el-button @click="close" size="small" type="info">关闭</el-button>
      </div>
      <el-dialog
              title="添加门店"
              :close-on-click-modal="false"
              :visible.sync="dialogVisibleShop"
              append-to-body
              width="1000px"
      >
        <div>
          <el-table
                  :data="shopList"
                  @selection-change="getChecked"
                  stripe
                  border
                  lazy
                  style="width: 100%"
                  size="small"
                  max-height="500"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    type="index"
                    label="编号"
                    :index="index => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
                    prop="shopCode"
                    label="商店编号"
                    header-align="center"
                    align="center"
            >
            </el-table-column>
            <el-table-column
                    prop="shopName"
                    label="商店名称"
                    header-align="center"
                    align="center"
            >
            </el-table-column>
            <el-table-column
                    prop="shopPhone"
                    label="电话"
                    header-align="center"
                    align="center"
            >
            </el-table-column>
            <el-table-column
                    prop="realname"
                    label="联系人/职员"
                    header-align="center"
                    align="center"
            >
            </el-table-column>
            <el-table-column
                    prop="phone"
                    label="联系人电话"
                    header-align="center"
                    align="center"
            >
            </el-table-column>
            <el-table-column
                    prop="shopAddress"
                    label="地址"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.shopAddress }}{{ scope.row.shopDetailAddress }}
              </template>
            </el-table-column>
            <el-table-column
                    prop="syncFlag"
                    label="是否实体店"
                    header-align="center"
                    align="center"
            >
              <template slot-scope="scope">
                <span>{{
                    scope.row.syncFlag === "hemiao" ? "虚拟店" : "实体店"
                  }}</span>
                <span></span>
              </template>
            </el-table-column>
            <el-table-column
                    prop="departName"
                    label="所属机构"
                    header-align="center"
                    align="center"
            >
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
                    background
                    :total="shopTotal"
                    @current-change="paging"
                    @size-change="handleSizeChange"
                    :page-sizes="[10, 50, 100, 200]"
                    layout="total,  prev, pager, next, jumper, sizes"
                    :current-page="currentPage"
            ></el-pagination>
          </div>
        </div>
        <div slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="addShop" size="small" type="primary"
          >确 认</el-button
          >

          <el-button @click="dialogVisibleShop = false" size="small" type="info"
          >关闭</el-button
          >
        </div>
      </el-dialog>
    </el-dialog>
    <hm-filter-employee
            v-if="dialogVisibleEmp"
            @setEmpInfo="setEmpInfo"
            :visible="dialogVisibleEmp"
            @close="dialogVisibleEmp = false"
    ></hm-filter-employee>
  </hm-content>
</template>

<script>
  import { arrayUnique2, toPrice, sub } from "@/utils/utils";
  import HmFilterEmployee from "@/components/HmFilterEmployee";
  // import { parse } from "path-to-regexp";
  export default {
    components: { HmFilterEmployee },
    data() {
      const patternDate = (rule, val, callback) => {
        if (val === "year") {
          if (
                  this.ruleForm.planStartDate === "" ||
                  this.ruleForm.planEndDate === ""
          ) {
            return callback(new Error("请选择时间段"));
          }
        } else {
          if (!this.ruleForm.timeDate || this.ruleForm.timeDate === "") {
            return callback(new Error("请选择时间段"));
          }
        }
        callback();
      };
      const patternList = (rule, val, callback) => {
        let flag = false;
        this.model.list.forEach(v => {
          if (v.splitValue === "") {
            flag = true;
          }
        });
        if (flag) {
          this.errShow = true;

          return callback();
        } else {
          this.errShow = false;
          callback();
        }
        callback();
      };
      return {
        showGoodsSn: true,
        dialogVisibleEmp: false,
        shopList: [],
        shopTotal: 0,
        pageSize: 10,
        currentPage: 1,
        dialogVisibleShop: false,
        status: "add",
        searchCondition: {
          subjectName: "shop"
        },
        model: {
          rules: {
            splitValue: [
              {
                required: true,
                message: "必填字段",
                trigger: "change"
              },
              { required: true, validator: patternList }
            ],
            planLeaderId: {
              required: true,
              message: "必填字段",
              trigger: "change"
            },
            planName: {
              required: true,
              message: "必填字段",
              trigger: "change"
            },
            placeholder: "123",
            // list: { required: true, validator: patternList }
          },
          list: [],
          columnList: []
        },

        list: [
          {
            date: "2020-2-2",
            splitRatio: "",
            splitValue: ""
          }
        ],
        headersList: [],
        columnList: [],
        tableHeader: [
          {
            labelName1: "门店/月度总计",
            labelName2: "",
            columnName: "shopName"
          },
          {
            labelName1: "负责人",
            labelName2: "张三和",
            columnName: "name"
          },
          {
            labelName1: "比例（%）",
            labelName2: "100",
            columnName: "splitRatio"
          },
          {
            labelName1: "1月",
            labelName2: "120000",
            columnName: "timeValue1"
          },
          {
            labelName1: "2月",
            labelName2: "220000",
            columnName: "timeValue2"
          },
          {
            labelName1: "3月",
            labelName2: "320000",
            columnName: "timeValue3"
          }
        ],
        type: "",
        dialogVisible: false,
        title: "",
        ruleForm: {
          planName: "",
          planValue: "",
          timeType: "",
          timeDate: "",
          planStartDate: "",
          planEndDate: "",
          planLeaderId: "",
          realName: "",
          planType: ""
        },
        //   { required: true, validator: patternFormStatus, trigger: "change" }
        rules: {
          planName: {
            required: true,
            message: "请输入制定目标名称",
            trigger: "blur"
          },
          planValue: {
            required: true,
            message: "请输入目标金额",
            trigger: "blur"
          },
          timeType: [
            {
              required: true,
              message: "请选择时间类型",
              trigger: "blur"
            },
            { required: true, validator: patternDate }
          ],
          planLeaderId: {
            required: true,
            message: "请输入责任人"
          },
          planType: {
            required: true,
            message: "请选择目标类型"
          }
        },
        pickerStartOptions: {
          disabledDate: time => {
            if (
                    this.ruleForm.planEndDate !== "" &&
                    this.ruleForm.planEndDate !== null
            ) {
              let maxYear = new Date(this.ruleForm.planEndDate).getFullYear();
              let minYear = new Date().getFullYear() + 1;
              return (
                      new Date(JSON.stringify(maxYear)) < time.getTime() ||
                      new Date(JSON.stringify(minYear)) > time.getTime()
              );
            } else {
              let minYear = new Date().getFullYear() + 1;
              return time.getTime() < new Date(JSON.stringify(minYear));
            }
          }
        },
        pickerOptions: {
          //disabled为函数，返回值为布尔值，
          disabledDate: time => {
            let minYear = new Date(this.ruleForm.planStartDate).getFullYear();
            return time.getTime() < new Date(JSON.stringify(minYear));
          }
        },
        pickerOption: {
          // 不让选择今天以前的
          disabledDate(time) {
            let curDate = new Date().getTime();
            // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
            let day = 30 * 24 * 3600 * 1000;
            let dateRegion = curDate - day;

            return time.getTime() - day < dateRegion;
            // return time.getTime() < Date.now() - 8.64e7;
          }
        },
        pickerOptionsMonth: {
          disabledDate(time) {
            let curDate = new Date();
            let year = curDate.getFullYear();
            let month = curDate.getMonth() + 1;
            let d = new Date(year, month, 0);
            let endTime = new Date(`${year}-${month}-${d.getDate()}`).getTime();
            return time.getTime() <= endTime;
            // var time = ""; //写自己要求的时间
            // var onlineTime = new Date(time).getTime();
            // return time.getTime() < onlineTime;
          }
        },
        pickerOptionsDate: {
          disabledDate(time) {
            return time.getTime() < Date.now();
          }
        },
        planValue: "",
        planId: "",
        planType: "",
        remainingRatio: "",
        okrPlanBasicInfo: {},
        row: {},
        checkedRow: [],
        copyRuleForm: {},
        copyList: [],
        errShow: false,
        index: 0,
        selectType: ""
      };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
      this.queryAllEmpList();
      this.queryOkrPlanType();
    },
    methods: {
      autoFill() {
        let num = 0;
        let lastIndex = 0;
        this.model.list.forEach((v, i) => {
          if (v.splitRatio === "" || v.splitRatio == null) {
            num++;
            lastIndex = i;
          }
        });
        let total = 0;
        let numRatio = (this.remainingRatio / num).toFixed(2);
        // let numArr = String(numRatio).split(".");

        // let numRatio2 = Math.floor(numRatio * 100) / 100;
        this.model.list.forEach((v, i) => {
          if ((v.splitRatio === "" || v.splitRatio == null) && i !== lastIndex) {
            v.splitRatio = numRatio;
          }
          this.percentageBlur(i);
          total = total + (v.splitRatio ? v.splitRatio * 1 : 0);
        });

        if (num > 0) {
          this.model.list[lastIndex].splitRatio = sub(100, total).toFixed(2);
          this.percentageBlur(lastIndex);
        }
      },
      toPriceNum(num) {
        if (isNaN(num)) {
          num = 0;
        }
        return (
                num &&
                num.toString().replace(/\d+/, function(s) {
                  return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
                })
        );
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            if (index === 3) {
              let num = sums[index].toFixed(2);
              sums[index] = num + "%";
            } else if (index === 2) {
              if (this.planType === 'salesAmount') {
                sums[index] = "￥" + toPrice(sums[index].toFixed(2));
              } else {
                sums[index] = sums[index];
              }
            } else if (index === 1) {
              sums[index] = "";
            }
          } else {
            sums[index] = "";
          }
        });

        return sums;
      },
      selectEmpList(i, type) {
        this.index = i;
        this.selectType = type;
        this.dialogVisibleEmp = true;
      },
      setEmpInfo(info) {
        console.log("this.selectType", this.selectType,  this.planValue, this.remainingRatio);
        let remainingRatio = this.remainingRatio;
        if (this.selectType === "list") {
          this.$nextTick(() => {
            this.model.columnList[this.index].planLeaderId = info.employeeId;
            this.model.columnList[this.index].planLeaderName = info.realname;
            this.model.columnList[this.index].showGoodsSn = false;
            // this.$set(
            //     this.model.columnList[this.index],
            //     "planLeaderName",
            //     info.realname
            // );
            this.labelNameBlur(this.model.columnList[this.index], this.index);
          });
          // this.$forceUpdate();
        } else {
          this.ruleForm.planLeaderId = info.employeeId;
          this.ruleForm.realName = info.realname;
        }
        console.log("type", this.type);
        this.$nextTick(() => {
          this.remainingRatio = remainingRatio;
          this.dialogVisibleEmp = false;
          this.showGoodsSn = false;
          // this.$forceUpdate();
        })
      },
      selectEmp() {
        this.dialogVisibleEmp = true;
      },
      addShops() {
        this.dialogVisibleShop = true;

        this.queryAllShopList();
      },
      addShop() {
        if (this.checkedRow.length) {
          this.checkedRow.forEach(v => {
            this.$set(v, "splitRatio", "");
            v.planLeaderName = v.realname;
            v.planLeaderId = v.employeeId;
          });
          this.model.columnList.push(...this.checkedRow);
          this.model.columnList = arrayUnique2(this.model.columnList, "shopId");
          this.dialogVisibleShop = false;
          this.$forceUpdate();
          setTimeout(() => {
            let inputfo = document.getElementsByClassName("addshops");
            inputfo[inputfo.length - 1].querySelector("input").focus();
            inputfo[inputfo.length - 1].querySelector("input").blur();
          }, 100);
        } else {
          this.$message({
            message: "请选择",
            type: "warning"
          });
        }
      },
      getChecked(selection) {
        this.checkedRow = selection;
      },
      handleSizeChange(size) {
        this.currentPage = 1;
        this.pageSize = size;
        this.queryAllShopList();
      },
      paging(page) {
        this.currentPage = page;
        this.queryAllShopList();
      },
      async queryAllShopList() {
        let shopIds = this.model.columnList.map(v => v.shopId);
        let params = {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          shopIds
        };

        const { result } = await this.$store.dispatch("queryShopList", params);
        const { records, total } = result;
        this.shopList = records;
        this.shopTotal = total;
      },
      edit(type, title) {
        this.status = "edit";
        this.type = type;
        this.title = title;
        this.dialogVisible = true;
        this.headersList = [];
        this.columnList = [];
        this.model.columnList = [];
        this.model.list = [];
        this.list = [];
        let total = 0;
        if (this.type === "1") {
          this.queryStoreOkrPlanBasicDetailsInfo();
        } else if (this.type === "2") {
          this.queryStoreOkrPlanSplitDetailsInfo().then(() => {
            this.model.list.forEach(v => {
              total += v.splitValue;
            });
            this.remainingRatio = this.planValue - total;
          });
        } else if (this.type === "3") {
          this.queryStoreOkrPlanSplitTargetDetailsInfo().then(() => {
            // this.queryRemainingRatio();
          });
        } else if (this.type === "4") {
          this.queryStoreOkrPlanSplitShopDetailsInfo().then(() => {
            // this.queryRemainingRatio();
            console.log("第四步:", this.remainingRatio);
          });
          this.model.list.forEach(v => {
            total += v.splitValue;
          });
          this.remainingRatio = this.planValue - total;
        }
      },
      subjectNameChange() {
        this.queryPreview();
      },
      async queryStoreOkrPlanBasicDetailsInfo() {
        const { code, result } = await this.$store.dispatch(
                "queryStoreOkrPlanBasicDetailsInfo"
        );
        if (code === "0") {
          for (let key in result) {
            this.ruleForm[key] = result[key];
          }
          if (result.timeType !== "year") {
            this.ruleForm.timeDate = [result.planStartDate, result.planEndDate];
          }
          this.copyRuleForm = JSON.parse(JSON.stringify(this.ruleForm));
        }
      },
      async queryStoreOkrPlanSplitDetailsInfo() {
        const { code, result } = await this.$store.dispatch(
                "queryStoreOkrPlanSplitDetailsInfo"
        );
        if (code === "0") {
          const { planValue, splitInfoModels, time_type, planType } = result;
          this.planValue = planValue;
          this.planType = planType;
          if (time_type === "year") {
            splitInfoModels.forEach(v => {
              v.timeValue = v.timeValue + "年";
            });
          }
          this.copyList = JSON.parse(JSON.stringify(splitInfoModels));
          this.model.list = splitInfoModels;
          // this.list = splitInfoModels;
        }
      },
      async queryOkrPlanShopAndTargetDetailsInfo() {
        const { code, result } = await this.$store.dispatch(
                "queryOkrPlanShopAndTargetDetailsInfo"
        );
        if (code === "0") {
          const { headersList, columnList } = result;
          this.headersList = headersList;
          this.columnList = columnList;
        }
      },
      async queryStoreOkrPlanSplitTargetDetailsInfo() {
        const { code, result } = await this.$store.dispatch(
                "queryStoreOkrPlanSplitTargetDetailsInfo"
        );
        if (code === "0") {
          const { headersList, columnList } = result;
          this.headersList = headersList;
          this.columnList = columnList;
          this.model.columnList = columnList;
          this.planValue = result.planValue;
          this.planType = result.planType;
          let remainingRatio = 0;
          if (columnList) {
            columnList.forEach(column=>{
              for(let c in column) {
                if (c.indexOf("splitValue") != -1) {
                  remainingRatio += Number(column[c]);
                }
              }
            })
          }
          this.remainingRatio = this.planValue - remainingRatio;
        }
      },
      async queryStoreOkrPlanSplitShopDetailsInfo() {
        const { code, result } = await this.$store.dispatch(
                "queryStoreOkrPlanSplitShopDetailsInfo"
        );
        if (code === "0") {
          const { headersList, columnList } = result;
          this.headersList = headersList;
          this.columnList = columnList;
          this.model.columnList = columnList;
          this.planValue = result.planValue;
          this.planType = result.planType;
          let remainingRatio = 0;
          if (columnList) {
            columnList.forEach(column=>{
              for(let c in column) {
                if (c.indexOf("splitValue") != -1) {
                  remainingRatio += Number(column[c]);
                }
              }
            })
          }
          this.remainingRatio = this.planValue - remainingRatio;
        }
      },
      del(i) {
        this.model.columnList.splice(i, 1);
        this.queryRemainingRatio();
      },
      add() {
        this.model.columnList.push(Object.assign({}, this.row));
        setTimeout(() => {
          let inputfo = document.getElementsByClassName("inputfo");
          inputfo[inputfo.length - 1].querySelector("input").focus();
        }, 100);
      },
      async queryStoreOkrPlanSplitTargetInfo() {
        const { code, result } = await this.$store.dispatch(
                "queryStoreOkrPlanSplitTargetInfo"
        );
        if (code === "0") {
          this.row = {};
          this.headersList = result.headersList;
          this.planType = result.planType;
          this.planValue = result.planValue;
          this.headersList.forEach(v => {
            this.row[v.columnName] = "";
          });
          this.remainingRatio = this.planValue;
        }
      },
      async queryOkrPlanType() {
        const { code, result } = await this.$store.dispatch(
                "queryStoreOkrPlanBasicInfo"
        );
        if (code === "0") {
          this.okrPlanBasicInfo = result;
        }
      },
      querySplitValue(row, i) {
        this.headersList.forEach(v => {
          if (
                  v.columnName.indexOf("splitValue") === 0 ||
                  v.columnName === "planValue"
          ) {
            //row[v.columnName] = (v.labelName2 * row.splitRatio * 0.01).toFixed(2);
          }
        });
        this.$set(this.model.columnList, i, this.model.columnList[i]);
      },
      queryRemainingRatio() {
        let total = 0;
        this.model.columnList.forEach(v => {
          total = total + (v.splitRatio ? v.splitRatio * 1 : 0);
          // total += v.splitRatio * 1;
        });
        this.remainingRatio = (100 - total).toFixed(2);
      },
      async queryStoreOkrPlanSplitShopInfo() {
        const { result, code } = await this.$store.dispatch(
                "queryStoreOkrPlanSplitShopInfo"
        );
        if (code === "0") {
          const { columnList, headersList } = result;
          this.model.columnList = columnList;
          this.columnList = columnList;
          this.headersList = headersList;
          this.planType = result.planType;
          this.planValue = result.planValue;
          let remainingRatio = 0;
          if (columnList) {
            columnList.forEach(column=>{
              for(let c in column) {
                if (c.indexOf("splitValue") != -1) {
                  remainingRatio += Number(column[c]);
                }
              }
            })
          }
          this.remainingRatio = this.planValue - remainingRatio;
          // this.columnList.forEach(v => {
          //   v.planLeaderId = "20508f8eac8e49789a5f390c461a3f23";
          //   v.splitRatio = 1;
          // });
        }
      },
      async queryStoreOkrPlanSplitInfo() {
        const { result, code } = await this.$store.dispatch(
                "queryStoreOkrPlanSplitInfo"
        );
        if (code === "0") {
          const { dateStr, planValue, planId, planType } = result;
          this.planValue = planValue;
          this.list = [];
          this.model.list = [];
          this.planId = planId;
          this.planType = planType;
          this.ruleForm.planType = planType;
          this.remainingRatio = planValue;
          if (dateStr.length) {
            dateStr.forEach(v => {
              this.list.push({
                timeValue: v,
                splitRatio: "",
                splitValue: ""
              });
              this.model.list.push({
                timeValue: v,
                splitRatio: "",
                splitValue: ""
              });
            });
          }
        }
      },
      async queryAllEmpList() {
        let params = {
          pageNo: 1,
          pageSize: 999999,
          workingState: "yes",
          loginType: "store"
        };
        const { result, code } = await this.$store.dispatch(
                "queryAllEmployeeList",
                params
        );
        if (code === "0") {
          this.allEmp = result.records;
        }
      },
      submitRuleForm(formName) {
        if (this.type === "1") {
          this.$refs[formName].validate(valid => {
            if (valid) {
              const params = JSON.parse(JSON.stringify(this.ruleForm));

              if (params.timeType === "month" || params.timeType === "date") {
                params.planStartDate = this.ruleForm.timeDate[0];
                params.planEndDate = this.ruleForm.timeDate[1];
              }
              params.planObject = "company";
              params.planType = this.ruleForm.planType;
              let name =
                      this.status === "edit"
                              ? "editStoreOkrPlanBasicInfo"
                              : "saveStoreOkrPlanBasicInfo";
              if (this.status === "edit") {
                params.operationType = "edit";
                let flag = true;
                for (let key in this.copyRuleForm) {
                  if (
                          key !== "timeDate" &&
                          params[key] != this.copyRuleForm[key]
                  ) {
                    flag = false;
                  }
                }
                if (flag) {
                  this.dialogVisible = false;
                  return;
                } else {
                  if (this.status === "edit") {
                    this.$confirm("确认修改当前页面数据吗？", "提示", {
                      cancelButtonText: "取消",
                      confirmButtonText: "确定",
                      type: "warning"
                    }).then(() => {
                      this.$confirm("确认修改后原数据将不会保留", "提示", {
                        cancelButtonText: "取消",
                        confirmButtonText: "确定",
                        type: "warning"
                      }).then(() => {
                        this.$store.dispatch(name, params).then(res => {
                          if (res.code === "0") {
                            this.$message({
                              message: "操作成功",
                              type: "success"
                            });
                            this.resetRuleForm();
                            this.queryOkrPlanType();
                            this.dialogVisible = false;
                          }
                        });
                      });
                    });
                  }
                }
              } else {
                this.$store.dispatch(name, params).then(res => {
                  if (res.code === "0") {
                    this.$message({
                      message: "操作成功",
                      type: "success"
                    });
                    this.resetRuleForm();
                    this.queryOkrPlanType();
                    this.dialogVisible = false;
                  }
                });
              }
            } else {
              return false;
            }
          });
        } else if (this.type === "2") {
          this.$refs[formName].validate(valid => {
            if (valid) {
              // let total = 0;
              // this.model.list.forEach(v => {
              //   total += v.splitRatio * 1;
              // });
              if (this.remainingRatio != 0) {
                this.$message({
                  message: "百分比合计需等于100",
                  type: "warning"
                });
              } else {
                let name =
                        this.status === "edit"
                                ? "editStoreOkrPlanSplitInfo"
                                : "saveStoreOkrPlanSplitInfo";
                let params = {
                  id: this.planId,
                  splitInfoModels: this.model.list
                };
                if (this.status === "edit") {
                  let flag = true;
                  for (let i = 0; i < this.copyList.length; i++) {
                    if (
                            this.copyList[i].splitRatio != this.model.list[i].splitRatio
                    ) {
                      flag = false;
                    }
                  }
                  if (flag) {
                    this.dialogVisible = false;
                    return;
                  } else {
                    if (this.status === "edit") {
                      this.$confirm("确认修改当前页面数据吗？", "提示", {
                        cancelButtonText: "取消",
                        confirmButtonText: "确定",
                        type: "warning"
                      }).then(() => {
                        this.$confirm("确认修改后原数据将不会保留", "提示", {
                          cancelButtonText: "取消",
                          confirmButtonText: "确定",
                          type: "warning"
                        }).then(() => {
                          this.$store.dispatch(name, params).then(res => {
                            if (res.code === "0") {
                              this.$message({
                                message: "操作成功",
                                type: "success"
                              });
                              this.resetRuleForm();
                              this.queryOkrPlanType();
                              this.dialogVisible = false;
                            }
                          });
                        });
                      });
                    }
                  }
                } else {
                  this.$store.dispatch(name, params).then(res => {
                    if (res.code === "0") {
                      this.$message({
                        message: "操作成功",
                        type: "success"
                      });
                      this.resetRuleForm();
                      this.queryOkrPlanType();
                      this.dialogVisible = false;
                    }
                  });
                }
              }
            } else {
              setTimeout(() => {
                var isError = document.getElementsByClassName("is-error");
                isError[0].querySelector("input").focus();
              }, 100);
              this.errShow = true;
            }
          });
        } else if (this.type === "3") {
          this.$refs[formName].validate(valid => {
            if (valid) {
              let flag = false;
              this.model.columnList.forEach(v => {
                if (
                        v.planLeaderId === "" ||
                        v.splitRatio === "" ||
                        v.planName === ""
                ) {
                  flag = true;
                }
              });
              if (flag) {
                this.$message({
                  message: "请填写完所有项",
                  type: "warning"
                });
              } else {
                let sum = 0;
                this.model.columnList.forEach(column => {
                  for(let c in column) {
                    if (c.indexOf("splitValue") != -1) {
                      sum += Number(column[c]);
                    }
                  }
                })
                if (sum != this.planValue) {
                  this.$message({
                    message: "总计值不相等",
                    type: "warning"
                  });
                } else {
                  let name =
                          this.status === "edit"
                                  ? "editStoreOkrPlanSplitTargetInfo"
                                  : "saveStoreOkrPlanSplitTargetInfo";
                  this.$store
                          .dispatch(name, {
                            columnList: this.model.columnList
                          })
                          .then(res => {
                            if (res.code === "0") {
                              this.$message({
                                message: "操作成功",
                                type: "success"
                              });
                              this.resetRuleForm();
                              this.queryOkrPlanType();
                              this.dialogVisible = false;
                            }
                          });
                }
              }
            }
          });
        } else if (this.type === "4") {
          this.$refs[formName].validate(valid => {
            if (valid) {
              let flag = false;
              this.model.columnList.forEach(v => {
                if (v.planLeaderId === "") {
                  flag = true;
                }
              });
              if (flag) {
                this.$message({
                  message: "请填写完所有项",
                  type: "warning"
                });
              } else {
                let sum = 0;
                this.model.columnList.forEach(column => {
                  for(let c in column) {
                    if (c.indexOf("splitValue") != -1) {
                      sum += Number(column[c]);
                    }
                  }
                })
                if (sum != this.planValue) {
                  this.$message({
                    message: "总计值不相等",
                    type: "warning"
                  });
                } else {
                  let name =
                          this.status === "edit"
                                  ? "editStoreOkrPlanSplitShopInfo"
                                  : "saveStoreOkrPlanSplitShopInfo";
                  this.$store
                          .dispatch(name, {
                            columnList: this.model.columnList
                          })
                          .then(res => {
                            if (res.code === "0") {
                              this.$message({
                                message: "操作成功",
                                type: "success"
                              });
                              this.resetRuleForm();
                              this.queryOkrPlanType();
                              this.dialogVisible = false;
                            }
                          });
                }
              }
            } else {
              return false;
            }
          });
        } else if (this.type === "5") {
          this.$store.dispatch("changePublishStatus").then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.resetRuleForm();
              this.queryOkrPlanType();
              this.dialogVisible = false;
              this.$router.push({
                name: "OkrWorkHome"
              });
            }
          });
        }
      },
      labelNameBlur(row, i) {
        this.querySplitValue(row, i);
        this.queryRemainingRatio();
      },
      percentageBlur(i) {
        console.log("目标剩余:" + this.planValue);
        console.log("当前设置目标:" + this.model.list[i].splitValue);
        console.log("this.remainingRatio:" + this.remainingRatio);

        let total = 0;
        this.model.list.forEach(v => {
          total = total + (v.splitValue ? v.splitValue * 1 : 0);
        });
        console.log("总设置:", total);
        if (this.planValue - total < 0) {
          this.$message({
            message: "剩余目标余额不足",
            type: "warning"
          });
          this.model.list[i].splitValue = 0;
          this.model.list[i].splitRatio = 0;
          return;
        }
        this.validation(i, this.model.list[i].splitValue, total);
      },
      targetBlur(i, row, index) {
        if (!this.remainingRatio) {
          this.remainingRatio = this.planValue;
        }
        let total = 0;
        for (let j = 0; j <= this.model.columnList.length; j++) {
          console.log(index, j)
          for (let c in this.model.columnList[j]) {
            if (c.indexOf("splitValue") != -1) {
              total += Number(this.model.columnList[j][c]);
            }
          }
        }
        let sum = 0;
        if (this.model.columnList) {
          for (let j = 0; j <= this.model.columnList.length; j++) {
            console.log(index,j)
            if (index === j) {
              for(let c in this.model.columnList[j]) {
                if (c.indexOf("splitValue") != -1) {
                  console.log("列:", c);
                  console.log("值:", this.model.columnList[j][c])
                  sum += Number(this.model.columnList[j][c]);
                }
              }
            }
          }
          this.remainingRatio = this.planValue - total;
        }
        row.planValue = sum;
      },
      validation(i, setRemainingRatio, total) {
        this.model.list[i].splitRatio = (setRemainingRatio / this.planValue).toFixed(2) * 100;
        this.remainingRatio = this.planValue - total;
        this.$set(this.model.list, i, this.model.list[i]);
      },
      close() {
        this.resetRuleForm();
        this.dialogVisible = false;
      },
      resetRuleForm() {
        setTimeout(() => {
          if (this.$refs.ruleForm) {
            this.$refs.ruleForm.resetFields();
          }
          this.list = [];
          this.planId = "";
          this.headersList = [];
          this.model.columnList = [];
        }, 0);
      },
      drawDateChange() {
        this.ruleForm.planStartDate = "";
        this.ruleForm.planEndDate = "";
        this.ruleForm.timeDate = "";
      },
      planTypeChange(v) {
        if (this.ruleForm.planValue && this.ruleForm.planType === 'salesAmount') {
          this.ruleForm.amount = this.ruleForm.planValue;
        } else if (this.ruleForm.planValue && this.ruleForm.planType === 'salesNum') {
          this.ruleForm.saleNum = this.ruleForm.planValue;
        }
      },
      goAdd(type, title) {
        this.status = "add";
        this.type = type;
        this.title = title;
        this.dialogVisible = true;
        this.model.columnList = [];
        this.columnList = [];
        this.headersList = [];
        this.remainingRatio = 0;
        this.$forceUpdate();
        if (type === "2") {
          this.queryStoreOkrPlanSplitInfo();
        } else if (type === "3") {
          this.queryStoreOkrPlanSplitTargetInfo();
        } else if (type === "4") {
          this.queryStoreOkrPlanSplitShopInfo();
        } else if (type === "5") {
          this.queryPreview();
        }
      },
      queryPreview() {
        this.headersList = [];
        this.columnList = [];
        if (this.searchCondition.subjectName === "shop") {
          this.queryStoreOkrPlanSplitShopDetailsInfo();
        } else if (this.searchCondition.subjectName === "child") {
          this.queryStoreOkrPlanSplitTargetDetailsInfo();
        } else {
          this.queryOkrPlanShopAndTargetDetailsInfo();
        }
      },
      filterGt0OrListModelFixed2(prop, i, list) {
        this.model[list][i][prop] = this.model[list][i][prop].replace(
                /[^\d.]/g,
                ""
        ); //仅保留数字和"."
        this.model[list][i][prop] = this.model[list][i][prop].replace(
                /\.{2,}/g,
                "."
        ); //两个连续的"."仅保留第一个"."
        this.model[list][i][prop] = this.model[list][i][prop]
                .replace(".", "$#*")
                .replace(/\./g, "")
                .replace("$#*", "."); //去除其他"."
        this.model[list][i][prop] = this.model[list][i][prop].replace(
                /^(\d+)\.(\d\d).*$/,
                "$1.$2"
        ); //限制只能输入两个小数
        if (
                this.model[list][i][prop].indexOf(".") < 0 &&
                this.model[list][i][prop] != ""
        ) {
          //首位是0的话去掉
          this.model[list][i][prop] = parseFloat(this.model[list][i][prop]);
        }
      },
      filterGt0OrListFixed2(prop, i, list) {
        this[list][i][prop] = this[list][i][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
        this[list][i][prop] = this[list][i][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this[list][i][prop] = this[list][i][prop]
                .replace(".", "$#*")
                .replace(/\./g, "")
                .replace("$#*", "."); //去除其他"."
        this[list][i][prop] = this[list][i][prop].replace(
                /^(\d+)\.(\d\d).*$/,
                "$1.$2"
        ); //限制只能输入两个小数
        if (this[list][i][prop].indexOf(".") < 0 && this[list][i][prop] != "") {
          //首位是0的话去掉
          this[list][i][prop] = parseFloat(this[list][i][prop]);
        }
      },
      filterGt0OrFixed2(prop) {
        // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
        this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
        this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.ruleForm[prop] = this.ruleForm[prop]
                .replace(".", "$#*")
                .replace(/\./g, "")
                .replace("$#*", "."); //去除其他"."
        this.ruleForm[prop] = this.ruleForm[prop].replace(
                /^(\d+)\.(\d\d).*$/,
                "$1.$2"
        ); //限制只能输入两个小数
        if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
          //首位是0的话去掉
          this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
        }
      }
    }
  };
</script>
<style lang="scss">
  .columnList {
    .ipt {
      .el-input__inner {
        text-align: right;
      }
    }
    .text-center {
      .el-input__inner {
        text-align: center;
      }
    }
    .ratioipt {
      & {
        width: 200px !important;
      }
    }
    .from-err {
      .el-form-item__error {
        top: 10px;
        left: 232px;
      }
      & {
        margin-bottom: 0px;
      }
    }
    .from-err-emp {
      .el-form-item__error {
        top: 10px;
        left: 20px;
      }
      & {
        margin-bottom: 0px;
      }
    }
    .from-err-plan-name {
      .el-form-item__error {
        top: 10px;
        left: 210px;
      }
      & {
        margin-bottom: 0px;
      }
    }
    .from-err-ratio {
      .el-form-item__error {
        top: 10px;
        left: 130px;
      }
      & {
        margin-bottom: 0px;
      }
    }
  }
  .okr-table-form {
    .el-select {
      width: 120px !important;
    }
  }
</style>
<style lang="scss" scoped>
  .okr-tip-bubble {
    // background: #ffffff;
    position: absolute;
    right: -239px;
    top: -15px;
    .bubble {
      max-width: 655px;
      width: 190px;
      position: relative;
      line-height: 30px;
      padding-left: 20px;
      padding-top: 10px;
      padding-bottom: 3px;
      border-radius: 7px;
      margin-top: 15px;
      padding-right: 10px;
      display: inline-block;

      box-shadow: 0px 0px 40px 0px rgba(216, 216, 216, 0.99);
      .title {
        color: #222222;
        font-size: 16px;
        font-weight: bold;
      }
      .child {
        font-size: 16px;
        color: #666666;
        .icon-daiban {
          font-size: 20px;
        }
      }
    }
    .leftBubble {
      position: relative;
      margin-left: 25px;
      border: 1px solid #ffffff;
      background-color: #ffffff;
    }
    .leftBubble .bottomLevel {
      position: absolute;
      top: 10px;
      left: -10px;
      border-top: 10px solid #ffffff;
      border-left: 10px solid transparent;
    }
    .leftBubble .topLevel {
      position: absolute;
      top: 11px;
      left: -8px;
      border-top: 10px solid #ffffff;
      border-left: 10px solid transparent;
      z-index: 100;
    }
  }
  .bm {
    border-top: 1px solid #ebeef5;
  }
  .fz16 {
    font-size: 16px;
  }
  // .ellipsis {
  //   max-width: 10px;
  //   overflow: hidden;
  //   white-space: nowrap;
  //   text-overflow: ellipsis;
  //   word-break: break-all;
  // }
  .tip-msg {
    .tip-img {
      width: 65px;
      height: 65px;
      background: #e50065;
      border-radius: 50%;
      img {
        width: 45px;
        height: 34px;
      }
      .tip-name {
        font-size: 11px;
        line-height: 19px;
        font-weight: 500;
        color: #ffffff;
      }
    }
    .bubbleItem {
      .bubble {
        max-width: 655px;
        position: relative;
        line-height: 30px;
        padding-left: 10px;
        padding-top: 3px;
        padding-bottom: 3px;
        border-radius: 7px;
        margin-top: 15px;
        padding-right: 10px;
        display: inline-block;
        color: #e50065;
      }
      .leftBubble {
        position: relative;
        margin-left: 25px;
        border: 1px solid #e50065;
        background-color: #fedeec;
      }
      .leftBubble .bottomLevel {
        position: absolute;
        top: 10px;
        left: -10px;
        border-top: 10px solid #e50065;
        border-left: 10px solid transparent;
      }
      .leftBubble .topLevel {
        position: absolute;
        top: 11px;
        left: -8px;
        border-top: 10px solid #fedeec;
        border-left: 10px solid transparent;
        z-index: 100;
      }
    }
  }
  .mt60 {
    margin-top: 60px;
  }
  .mr110 {
    margin-right: 68px;
  }
  .ml110 {
    margin-left: 68px;
  }
  .inline-block {
    display: inline-block;
  }
  .x-scroll {
    overflow: auto;
    overflow-y: hidden;
  }
  .ork-module {
    position: relative;
    width: 194px;
    height: 223px;
    background: #ffffff;
    box-shadow: 0px 0px 40px 0px rgba(216, 216, 216, 0.39);
    padding: 10px;
    .edit {
      position: absolute;
      left: 0;
      top: 0;
      background: #ffffff;
      display: none;
      .icon-bianji {
        font-size: 20px;
      }
    }
    &:hover {
      .ork-module-btn-wrapper {
        display: block;
      }
    }
    &-btn-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 38px;
      height: 169px;
      padding-left: 85px;
      display: none;
      background: rgba(0, 0, 0, 0.5);
      z-index: 233;
      .wrapper {
        height: 100%;
      }
      .el-button {
        margin: 0;
        margin-top: 20px;
        margin-right: 15px;
      }
    }
    .okr-img {
      height: 150px;
      width: 192px;
      background: #fff1f7;
      img {
        width: 100%;
        // height: 84px;
      }
    }
    .ork-title {
      font-weight: 600;
      color: #222222;
      height: 52px;
      line-height: 52px;
      font-size: 16px;
    }
    .okr-btn {
      margin-top: 10px;
      width: 100%;
      height: 36px;
      border-radius: 4px;
    }
    .okr-btn-false {
      margin-top: 10px;
      width: 100%;
      height: 36px;
      border-radius: 4px;
      background: #dddddd;
      border-color: #dddddd;
    }
    .okr-btn-success {
      margin-top: 10px;
      width: 100%;
      height: 36px;
      border-radius: 4px;
      background: #2fc348;
      border-color: #2fc348;
    }
    .line {
      position: absolute;
      right: -60px;
      bottom: 120px;
      width: 55px;
      height: 6px;
      background: #eeeeee;
    }
    .left-line {
      position: absolute;
      left: -60px;
      bottom: 120px;
      width: 55px;
      height: 6px;
      background: #eeeeee;
    }
  }
  .ml65 {
    margin-left: 40px;
  }
  .mr65 {
    margin-right: 40px;
  }
  .okr-small-module {
    position: relative;
    .left-vertical {
      position: absolute;
      top: 130px;
      left: 0;
      width: 30px;
      height: 355px;
      border: 6px solid #eeeeee;
      border-right: none;
      display: inline-block;
    }
    .right-vertical {
      position: absolute;
      top: 130px;
      right: 0;
      width: 30px;
      height: 355px;
      border: 6px solid #eeeeee;
      border-left: none;
      display: inline-block;
    }
  }


</style>
